import React from 'react'

import { Icon } from '@fourthwall/components'
import { ResetCircleIcon } from '@fourthwall/icons'

import type { OnboardingListProps } from '../OnboardingList'
import { OnboardingList } from '../OnboardingList'
import * as S from './styled'

type SkipProps =
  | {
      skipLabel: string
      onSkip: () => void
    }
  | {
      skipLabel?: never
      onSkip?: never
    }

export type OnboardingProps = {
  progress: {
    title: string
    percentage: number
  }
  onboardingListProps: OnboardingListProps
} & SkipProps

export const Onboarding = ({
  progress,
  onboardingListProps,
  skipLabel,
  onSkip,
}: OnboardingProps) => {
  const renderSkipButton = () => {
    if (!onSkip) return null

    return (
      <S.SkipButton onClick={onSkip} data-analytics="skipChecklist">
        <Icon component={ResetCircleIcon} height={14} />
        {skipLabel}
      </S.SkipButton>
    )
  }

  const getProgressWidth = () => {
    // NOTE: we don't want to display empty bar by design
    return `${progress.percentage || 2}%`
  }

  return (
    <div>
      <header>
        <S.TitleContainer>
          <S.Title>{progress.title}</S.Title>
          {renderSkipButton()}
        </S.TitleContainer>
        <S.Progress>
          <S.ProgressFill style={{ width: getProgressWidth() }} />
        </S.Progress>
      </header>
      <OnboardingList {...onboardingListProps} />
    </div>
  )
}
